import type { DefaultRootState } from 'react-redux';

export default (state: DefaultRootState) => {
  return state.ask.source.available.find((item) => item.id === state.ask.source.selectedId);
};
